import React from "react";
import { useLocation } from "react-router-dom";
import { adaVersiBaru, diaturSendiri, muatLangsung, versiSah, INTERVAL_CEK_MS } from "@/lib/versi";
import { useUnggahan } from "@/context/UnggahanContext";

const LOKAL = process.env.REACT_APP_VERSI;
const KUNCI = "soq_muat_ulang_untuk";

const baca = () => { try { return sessionStorage.getItem(KUNCI); } catch { return null; } };
// remember which version we reloaded for: if the page still is not that
// version afterwards, only the banner shows (never a reload loop)
const muatUlang = (versi) => { try { sessionStorage.setItem(KUNCI, versi); } catch { /* private mode */ } window.location.reload(); };

// fix/pwa-versi (2026-10-08): a page left open (installed app on a phone,
// the TV) keeps running the old screens after a deploy. Check /version.json
// every few minutes and whenever the app comes back to the front; when a
// newer version is out, show a banner and load it on the next menu change
// (never in the middle of a form). The TV loads it at once.
export default function VersiBaru() {
  const { pathname } = useLocation();
  const [baru, setBaru] = React.useState(null);  // the newer version, or null
  const halamanSaatTahu = React.useRef(null);
  const { antrean, daftar } = useUnggahan() || {};
  const unggahJalan = !!antrean && daftar.length > 0 && antrean.belumSelesai(); // v2.22.2: never reload over an upload

  const cek = React.useCallback(async () => {
    try {
      const r = await fetch("/version.json", { cache: "no-store" });
      if (!r.ok) return;
      const { versi } = await r.json();
      if (adaVersiBaru(LOKAL, versi)) {
        if (navigator.serviceWorker) navigator.serviceWorker.getRegistration().then((g) => g && g.update()).catch(() => {});
        setBaru(versi);
      }
    } catch { /* offline or not deployed: try again later */ }
  }, []);

  React.useEffect(() => {
    if (!versiSah(LOKAL)) return undefined; // build without a commit ("dev"): off
    cek();
    const t = setInterval(cek, INTERVAL_CEK_MS);
    const muncul = () => { if (document.visibilityState === "visible") cek(); };
    document.addEventListener("visibilitychange", muncul);
    return () => { clearInterval(t); document.removeEventListener("visibilitychange", muncul); };
  }, [cek]);

  React.useEffect(() => {
    if (unggahJalan) { halamanSaatTahu.current = null; return; }  // after the upload: wait for the next menu change again
    if (!baru || baca() === baru || diaturSendiri(pathname)) return;  // already reloaded once for this version: banner only
    if (muatLangsung(pathname)) { muatUlang(baru); return; }
    if (halamanSaatTahu.current === null) { halamanSaatTahu.current = pathname; return; }
    if (pathname !== halamanSaatTahu.current) muatUlang(baru);  // menu changed: nothing typed is lost
  }, [baru, pathname, unggahJalan]);

  if (!baru || diaturSendiri(pathname) || (muatLangsung(pathname) && baca() !== baru)) return null;
  return (
    <div data-testid="versi-baru" role="status" className="fixed inset-x-0 bottom-0 z-50 flex flex-wrap items-center justify-center gap-3 border-t border-amber-400/50 bg-amber-500 px-4 py-2 text-sm font-medium text-slate-950">
      <span>{unggahJalan ? "Versi baru SOQPRINT tersedia — dimuat setelah unggahan file master selesai." : "Versi baru SOQPRINT tersedia — dimuat otomatis saat pindah menu."}</span>
      <button data-testid="versi-baru-muat" onClick={() => muatUlang(baru)} className="rounded-md bg-slate-950 px-3 py-1 text-xs font-semibold text-amber-300">Muat ulang sekarang</button>
      <span className="text-xs">(isian yang belum disimpan akan hilang)</span>
    </div>
  );
}
